import invariant from 'invariant';
import { AnyAction } from 'redux';

import { RoomPresentationActions } from 'craft/state/room/types';
import { RoomSessions, SessionId, SocketState } from 'craft/types';
import RoomWorker from 'craft/workers/room/room.worker';
import { RoomWorkerActions } from 'craft/workers/room/types';

import { getSessionId } from './getSessionId';

export interface RoomPresentationState {
  socketState: SocketState;
  sessions: RoomSessions;
  sessionId: SessionId;
  /** A room worker is used to abstract the state and simplify the redux state */
  roomWorker: typeof RoomWorker;
}

export const getInitialState = (): RoomPresentationState => ({
  socketState: SocketState.CLOSED,
  // no sessions are avaliable when we bootstrap the state
  sessions: [],
  sessionId: getSessionId(),
  roomWorker: new RoomWorker(),
});

export const roomReducer = (
  state: RoomPresentationState = getInitialState(),
  action: AnyAction,
) => {
  const { roomWorker, sessionId } = state;
  // @ts-ignore
  const postMessage = (message) => roomWorker.postMessage(message);

  switch (action.type) {
    case RoomPresentationActions.CLOSE_ROOM:
      postMessage({
        type: RoomPresentationActions.CLOSE_ROOM,
      });
      return state;

    case RoomPresentationActions.JOIN_ROOM:
      // sanity check...
      invariant(
        state.socketState === SocketState.CLOSED,
        'The socket is already open, you cannot join another room',
      );
      // we ask the new worker to join a room
      postMessage({
        type: RoomPresentationActions.JOIN_ROOM,
        sessionId,
        contentId: action.contentId,
      });
      return state;

    /**
     * Set a given state for the socket, so we can display if
     * it is connected or not.
     */
    case RoomWorkerActions.SET_SOCKET_STATE:
      return { ...state, socketState: action.socketState };

    case RoomWorkerActions.SET_SESSIONS:
      return { ...state, sessions: action.sessions };

    default:
      return state;
  }
};
